(function() {
  console.log('[CART-SHOPIFY-FIX] Iniciando');

  let isOpening = false;
  let linkFixed = false;

  function openCartDrawer() {
    if (isOpening) return;
    isOpening = true;
    
    const drawer = document.getElementById('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
    }
    
    setTimeout(() => { isOpening = false; }, 500);
  }

  function fixCartHeaderLink() {
    if (linkFixed) return;
    
    const cartLink = document.querySelector('a[aria-controls="cart-drawer"]');
    if (!cartLink) return;

    const newLink = cartLink.cloneNode(true);
    newLink.removeAttribute('href');

    newLink.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      openCartDrawer();
      return false;
    }, true);

    cartLink.parentNode.replaceChild(newLink, cartLink);
    linkFixed = true;
  }

  function protectDrawer() {
    const drawer = document.getElementById('cart-drawer');
    if (!drawer) {
      setTimeout(protectDrawer, 500);
      return;
    }

    if (drawer.dataset.protected) return;
    drawer.dataset.protected = 'true';

    drawer.addEventListener('click', function(e) {
      const link = e.target.closest('a[href*="/cart/change"], a[href*="/cart/update"]');
      
      if (!link) return;
      
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      
      const url = new URL(link.href);
      const id = url.searchParams.get('id');
      const quantity = url.searchParams.get('quantity') || 0;
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: id,
          quantity: parseInt(quantity)
        })
      })
      .then(response => {
        if (!response.ok) throw new Error('Erro na requisição');
        return response.json();
      })
      .then(cart => {
        document.querySelectorAll('cart-count').forEach(count => {
          count.textContent = cart.item_count;
        });
        
        return fetch('/?sections=cart-drawer');
      })
      .then(response => response.json())
      .then(sections => {
        const drawerHTML = sections['cart-drawer'];
        
        if (drawerHTML) {
          const parser = new DOMParser();
          const doc = parser.parseFromString(drawerHTML, 'text/html');
          const newDrawer = doc.querySelector('cart-drawer');
          
          if (newDrawer) {
            drawer.innerHTML = newDrawer.innerHTML;
          }
        }
      })
      .catch(err => {
        console.error('[CART-SHOPIFY-FIX] Erro:', err);
        window.location.href = link.href.split('?')[0] + '?id=' + id + '&quantity=' + quantity;
      });
      
      return false;
    }, true);
  }

  function init() {
    fixCartHeaderLink();
    protectDrawer();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 100);
  }

  setTimeout(init, 1000);

})();